import { Schema } from "effect";
import { RunRequestPayload, RunResponse } from "@workerstation/shared/runtime/run-dispatch";
import { HostedTestBody } from "@workerstation/shared/hosted-test/http";
import { TestRunResult } from "@workerstation/shared/hosted-test-result";
import { ResourceRequestError, ResourceStorageError } from "@workerstation/shared/errors/resource";
import { HostedTestHttpError } from "@workerstation/shared/errors/hosted-test-http";

export const PreviewRequest = RunRequestPayload;
export type PreviewRequest = typeof PreviewRequest.Type;
export const PreviewResult = RunResponse;
export type PreviewResult = typeof PreviewResult.Type;
export const HostedRequest = HostedTestBody;
export type HostedRequest = typeof HostedRequest.Type;
export const HostedResult = TestRunResult;
export type HostedResult = typeof HostedResult.Type;
export const ExecutionFailure = Schema.Union([ResourceRequestError, HostedTestHttpError, ResourceStorageError]);
export type ExecutionFailure = typeof ExecutionFailure.Type;
